import axiosInstance from '../http/axios_instance'
const http = axiosInstance('/protected/orgadmin/', null, '/dashboard')

const getAllReportDetails = filters => http.post('/report_details', filters)
const getManagementReports = body => http.post('/management_reports', body)
const downloadCSV = filters => http.post('/reports_csv', filters)

const getReportsData = body => {
	console.log('[orgadmin_report] → POST /protected/orgadmin/reports_data', body)
	const req = http.post('/reports_data', body)
	req
		.then(res =>
			console.log('[orgadmin_report] ← reports_data', res && res.data),
		)
		.catch(err =>
			console.error(
				'[orgadmin_report] ✗ reports_data',
				err && (err.response ? err.response.status : err.message),
			),
		)
	return req
}

export default {
	getAllReportDetails,
	getManagementReports,
	downloadCSV,
	getReportsData,
}
